// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu{
    top: 0;
    left: 0;
    z-index: 2000;
}

.menu .menuLanding{
    align-items: center;
    padding: 30px 0;
}

.menu-registro .menuLanding{
    margin: 30px 80px 10px 80px;
}

.menu .logo{ width: 200px; }

/* -----------------------------------------------------------------------------
// LOGO SECTION AND FUNDING TEXT
// ----------------------------------------------------------------------------- */
.logo-section {
    display: flex;
    align-items: center;
    gap: 20px;
}

.funding-text {
    display: flex;
    align-items: center;
    margin-left: 20px;
}

.funding-text p {
    margin: 0;
    font-size: 13px;
    line-height: 1.3;
    color: #333;
    text-align: left;
    max-width: 600px;
}

/* -----------------------------------------------------------------------------
// MENU SIN REGISTRAR
// ----------------------------------------------------------------------------- */
.menu .menuLanding .botones{ gap: 35px; }

.registro{ color: black; }
.registro:hover{ text-decoration: underline; }

.inicio{
    border: 2px solid #007932;
    border-radius: 12px;
    padding: 6px 20px;
    line-height: 1.1;
}

.inicio:hover{
    background-color: #007932;
    color: white;
    text-decoration: none;
}


/* -----------------------------------------------------------------------------
// MENU PARA USUARIOS
// ----------------------------------------------------------------------------- */
.menu .menuUsuario{
    align-items: center;
    margin: 25px 80px 20px 80px;
}

.menuUsuario .opciones{ gap: 50px; }

.menuUsuario .opcion{
    align-items: center;
    gap: 7.5px;
    line-height: 1;
}

.menuUsuario a:hover{
    color: #007932;
    text-decoration: none;
}

/* Active state for user menu */
.menuUsuario .activo{
    color: #007932 !important;
}

.menuUsuario svg{ font-size: 26px; }
.menuUsuario .notificaciones svg{ font-size: 18px; }
.menuUsuario .notificaciones{ line-height: 0; }
.menuUsuario .perfil a{ margin-left: 16px; }

.menuUsuario .usuario{
    text-align: right;
    margin-right: 10px;
}

.menuUsuario .usuario p, .submenuUsuario .alerta p{ margin: 0px; line-height: 1;}
.menuUsuario .perfil svg{ margin-top: 11px;}

/* Logout button styling */
.logout-btn{
    background: none !important;
    border: none !important;
    color: inherit;
    font-size: inherit;
    padding: 0;
    margin-left: 16px;
    cursor: pointer;
}

.logout-btn:hover{
    color: #007932 !important;
}

.logout-btn svg{
    font-size: 26px;
    margin-top: 11px;
}

.submenuUsuario{
    background-color: #007932; /* #43B4C8; */
    align-items: center;
    padding: 7.5px 80px;
}

.submenuUsuario .alerta{ gap: 7.5px;}
.submenuUsuario .alerta svg{ font-size: 24px;}
.submenuUsuario .iconosMenu{ gap: 10px; }
.submenuUsuario .iconosMenu svg{ font-size: 18px; }
.submenuUsuario .iconosMenu svg:hover{ color: white;}


/* -----------------------------------------------------------------------------
// MENU PARA TÉCNICOS
// ----------------------------------------------------------------------------- */
.menu .menuTecnico{
    align-items: center;
    margin: 25px auto;
    height: 100px;
}

.menuTecnico .usuario{ text-align: right; }
.menuTecnico svg{ font-size: 26px; }

.menuTecnico .usuario p{ 
    margin: 0px; 
    line-height: 1; 
}

.menuTecnico .perfil a{ margin-left: 16px; }
.menuTecnico .perfil svg{ margin-top: 11px;}

.menuTecnico a:hover, .submenuTecnico a:hover{
    color: #007932; 
    text-decoration: none;
}

/* Active state for technical menu */
.menuTecnico .activo{
    color: #007932 !important;
}

/* Technical menu logout button */
.menuTecnico .logout-btn{
    margin-left: 16px;
}

.menuTecnico .logout-btn:hover{
    color: #007932 !important;
}

.submenuTecnico{
    align-items: center;
    padding: 7.5px 0 10px 0;
}
.main-menu-border{
border-bottom: 2px solid #007932; 
}

.submenuTecnico .opciones{ gap: 30px; }

.submenuTecnico .opcion{
    align-items: center;
    gap: 5px;
    line-height: 0.7;
}

/* Active state for technical submenu */
.submenuTecnico .activo{
    color: #007932 !important;
}

.submenuTecnico svg{ font-size: 20px; }
.submenuTecnico .iconosMenu{ gap: 10px; }


/* -----------------------------------------------------------------------------
// BANNER LOGOS
// ----------------------------------------------------------------------------- */
.banner{
    margin: 0px;
    padding: 10px 0;
    background-color: white;
}

.banner img{
    display: block;
    width: 75%;
    max-width: 900px;
    margin: 0 auto;
}


/* -----------------------------------------------------------------------------
// COOKIE BANNER
// ----------------------------------------------------------------------------- */
.cookie-banner{
    position: fixed;
    bottom: 25px;
    right: 20px;
    border-radius: 20px;
    width: 400px;
    z-index: 5000;
    padding: 20px;
    background-color: #fff;
    box-shadow: 14px 14px 26px -4px rgba(194,194,194,1);
    border: 1px solid #007932;
    border-left: 12px solid #007932;
}

.cookie-banner .titulo{ font-size: 18px; }
.cookie-banner .titulo svg{ font-size: 24px; }

.cookie-banner .aceptar{ 
    background-color: #007932;
    color: #fff;
}

.cookie-banner button:hover{ 
    background-color: #000;
    border: 2px solid #000;
}

/* .guest.menu .menuLanding {
    margin-bottom: 10px;
} */

.guest .submenuTecnico{
    margin-bottom: 30px;
    display: none;
}

@media (max-width: 1024px) {
  .main-menu-border {
   overflow-x: scroll;
     scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  }

  .guest .submenuTecnico {
    padding-left: 30px;
    padding-right: 30px;
}

  .menu .menuLanding {
    padding: 30px 30px;
}

  .main-menu-border::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

  .submenuTecnico {
    gap: 3rem;
}
}



@media (min-width: 1024px){
    .guest .submenuTecnico{
   display: flex
}
}



@media (max-width: 820px) {
    .menu .menuLanding{ padding: 20px 30px; }
    
    .funding-text p {
        font-size: 10px;
        max-width: 300px;
    }
}

@media (max-width: 768px) {
    .inicio {
        order: 0;
        border: none;
        padding: 0px;
    }

    .registro{ order: 1; }

    .menu .logo { width: 120px; }
    
    .logo-section {
        gap: 15px;
    }
    
    .funding-text {
        margin-left: 15px;
    }
    
    .funding-text p {
        font-size: 9px;
        max-width: 250px;
        line-height: 1.2;
    }
}

@media (max-width: 600px) {
    /* .menu .menuLanding{ margin: 20px 7.5%; } */
    .menu .menuLanding .botones { gap: 15px; }
    
    .logo-section {
        gap: 10px;
    }
    
    .funding-text {
        margin-left: 10px;
    }
    
    .funding-text p {
        font-size: 8px;
        max-width: 200px;
    }
}

@media (max-width: 400px) {
    .menu .menuLanding .botones { 
        flex-direction: column;
        gap: 5px; 
    }
    
    .funding-text {
        display: none; /* Hide funding text on very small screens */
    }
}

.notificacion-alerta {
    position: relative;
  }
  
  .notificacion-alerta::after {
    content: "";
    position: absolute;
    top: -5px;
    right: -5px;
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 50%;
  }
`, "",{"version":3,"sources":["webpack://./src/components/css/Navbar.css"],"names":[],"mappings":"AAAA;IACI,MAAM;IACN,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,aAAa,YAAY,EAAE;;AAE3B;;kFAEkF;AAClF;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;kFAEkF;AAClF,6BAA6B,SAAS,EAAE;;AAExC,WAAW,YAAY,EAAE;AACzB,iBAAiB,0BAA0B,EAAE;;AAE7C;IACI,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;;AAGA;;kFAEkF;AAClF;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA,wBAAwB,SAAS,EAAE;;AAEnC;IACI,mBAAmB;IACnB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA,+BAA+B;AAC/B;IACI,yBAAyB;AAC7B;;AAEA,kBAAkB,eAAe,EAAE;AACnC,kCAAkC,eAAe,EAAE;AACnD,8BAA8B,cAAc,EAAE;AAC9C,wBAAwB,iBAAiB,EAAE;;AAE3C;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,oDAAoD,WAAW,EAAE,cAAc,CAAC;AAChF,0BAA0B,gBAAgB,CAAC;;AAE3C,0BAA0B;AAC1B;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB,EAAE,aAAa;IACxC,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,yBAAyB,UAAU,CAAC;AACpC,6BAA6B,eAAe,CAAC;AAC7C,6BAA6B,SAAS,EAAE;AACxC,iCAAiC,eAAe,EAAE;AAClD,uCAAuC,YAAY,CAAC;;;AAGpD;;kFAEkF;AAClF;IACI,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;AACjB;;AAEA,uBAAuB,iBAAiB,EAAE;AAC1C,kBAAkB,eAAe,EAAE;;AAEnC;IACI,WAAW;IACX,cAAc;AAClB;;AAEA,wBAAwB,iBAAiB,EAAE;AAC3C,0BAA0B,gBAAgB,CAAC;;AAE3C;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA,oCAAoC;AACpC;IACI,yBAAyB;AAC7B;;AAEA,iCAAiC;AACjC;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;AACA,gCAAgC;AAChC;;AAEA,2BAA2B,SAAS,EAAE;;AAEtC;IACI,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA,uCAAuC;AACvC;IACI,yBAAyB;AAC7B;;AAEA,qBAAqB,eAAe,EAAE;AACtC,6BAA6B,SAAS,EAAE;;;AAGxC;;kFAEkF;AAClF;IACI,WAAW;IACX,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,cAAc;AAClB;;;AAGA;;kFAEkF;AAClF;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IAGtB,mDAAmD;IACnD,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA,wBAAwB,eAAe,EAAE;AACzC,4BAA4B,eAAe,EAAE;;AAE7C;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;;GAEG;;AAEH;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;EACE;GACC,kBAAkB;KAChB,qBAAqB,EAAE,YAAY;EACtC,wBAAwB,EAAE,gBAAgB;EAC1C;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;AACvB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;EACA,aAAa,EAAE,0BAA0B;AAC3C;;EAEE;IACE,SAAS;AACb;AACA;;;;AAIA;IACI;GACD;AACH;AACA;;;;AAIA;IACI,oBAAoB,kBAAkB,EAAE;;IAExC;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,YAAY;QACZ,YAAY;IAChB;;IAEA,WAAW,QAAQ,EAAE;;IAErB,cAAc,YAAY,EAAE;;IAE5B;QACI,SAAS;IACb;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;AAEA;IACI,6CAA6C;IAC7C,8BAA8B,SAAS,EAAE;;IAEzC;QACI,SAAS;IACb;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,aAAa,EAAE,4CAA4C;IAC/D;AACJ;;AAEA;IACI,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;EACpB","sourcesContent":[".menu{\n    top: 0;\n    left: 0;\n    z-index: 2000;\n}\n\n.menu .menuLanding{\n    align-items: center;\n    padding: 30px 0;\n}\n\n.menu-registro .menuLanding{\n    margin: 30px 80px 10px 80px;\n}\n\n.menu .logo{ width: 200px; }\n\n/* -----------------------------------------------------------------------------\n// LOGO SECTION AND FUNDING TEXT\n// ----------------------------------------------------------------------------- */\n.logo-section {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.funding-text {\n    display: flex;\n    align-items: center;\n    margin-left: 20px;\n}\n\n.funding-text p {\n    margin: 0;\n    font-size: 13px;\n    line-height: 1.3;\n    color: #333;\n    text-align: left;\n    max-width: 600px;\n}\n\n/* -----------------------------------------------------------------------------\n// MENU SIN REGISTRAR\n// ----------------------------------------------------------------------------- */\n.menu .menuLanding .botones{ gap: 35px; }\n\n.registro{ color: black; }\n.registro:hover{ text-decoration: underline; }\n\n.inicio{\n    border: 2px solid #007932;\n    border-radius: 12px;\n    padding: 6px 20px;\n    line-height: 1.1;\n}\n\n.inicio:hover{\n    background-color: #007932;\n    color: white;\n    text-decoration: none;\n}\n\n\n/* -----------------------------------------------------------------------------\n// MENU PARA USUARIOS\n// ----------------------------------------------------------------------------- */\n.menu .menuUsuario{\n    align-items: center;\n    margin: 25px 80px 20px 80px;\n}\n\n.menuUsuario .opciones{ gap: 50px; }\n\n.menuUsuario .opcion{\n    align-items: center;\n    gap: 7.5px;\n    line-height: 1;\n}\n\n.menuUsuario a:hover{\n    color: #007932;\n    text-decoration: none;\n}\n\n/* Active state for user menu */\n.menuUsuario .activo{\n    color: #007932 !important;\n}\n\n.menuUsuario svg{ font-size: 26px; }\n.menuUsuario .notificaciones svg{ font-size: 18px; }\n.menuUsuario .notificaciones{ line-height: 0; }\n.menuUsuario .perfil a{ margin-left: 16px; }\n\n.menuUsuario .usuario{\n    text-align: right;\n    margin-right: 10px;\n}\n\n.menuUsuario .usuario p, .submenuUsuario .alerta p{ margin: 0px; line-height: 1;}\n.menuUsuario .perfil svg{ margin-top: 11px;}\n\n/* Logout button styling */\n.logout-btn{\n    background: none !important;\n    border: none !important;\n    color: inherit;\n    font-size: inherit;\n    padding: 0;\n    margin-left: 16px;\n    cursor: pointer;\n}\n\n.logout-btn:hover{\n    color: #007932 !important;\n}\n\n.logout-btn svg{\n    font-size: 26px;\n    margin-top: 11px;\n}\n\n.submenuUsuario{\n    background-color: #007932; /* #43B4C8; */\n    align-items: center;\n    padding: 7.5px 80px;\n}\n\n.submenuUsuario .alerta{ gap: 7.5px;}\n.submenuUsuario .alerta svg{ font-size: 24px;}\n.submenuUsuario .iconosMenu{ gap: 10px; }\n.submenuUsuario .iconosMenu svg{ font-size: 18px; }\n.submenuUsuario .iconosMenu svg:hover{ color: white;}\n\n\n/* -----------------------------------------------------------------------------\n// MENU PARA TÉCNICOS\n// ----------------------------------------------------------------------------- */\n.menu .menuTecnico{\n    align-items: center;\n    margin: 25px auto;\n    height: 100px;\n}\n\n.menuTecnico .usuario{ text-align: right; }\n.menuTecnico svg{ font-size: 26px; }\n\n.menuTecnico .usuario p{ \n    margin: 0px; \n    line-height: 1; \n}\n\n.menuTecnico .perfil a{ margin-left: 16px; }\n.menuTecnico .perfil svg{ margin-top: 11px;}\n\n.menuTecnico a:hover, .submenuTecnico a:hover{\n    color: #007932; \n    text-decoration: none;\n}\n\n/* Active state for technical menu */\n.menuTecnico .activo{\n    color: #007932 !important;\n}\n\n/* Technical menu logout button */\n.menuTecnico .logout-btn{\n    margin-left: 16px;\n}\n\n.menuTecnico .logout-btn:hover{\n    color: #007932 !important;\n}\n\n.submenuTecnico{\n    align-items: center;\n    padding: 7.5px 0 10px 0;\n}\n.main-menu-border{\nborder-bottom: 2px solid #007932; \n}\n\n.submenuTecnico .opciones{ gap: 30px; }\n\n.submenuTecnico .opcion{\n    align-items: center;\n    gap: 5px;\n    line-height: 0.7;\n}\n\n/* Active state for technical submenu */\n.submenuTecnico .activo{\n    color: #007932 !important;\n}\n\n.submenuTecnico svg{ font-size: 20px; }\n.submenuTecnico .iconosMenu{ gap: 10px; }\n\n\n/* -----------------------------------------------------------------------------\n// BANNER LOGOS\n// ----------------------------------------------------------------------------- */\n.banner{\n    margin: 0px;\n    padding: 10px 0;\n    background-color: white;\n}\n\n.banner img{\n    display: block;\n    width: 75%;\n    max-width: 900px;\n    margin: 0 auto;\n}\n\n\n/* -----------------------------------------------------------------------------\n// COOKIE BANNER\n// ----------------------------------------------------------------------------- */\n.cookie-banner{\n    position: fixed;\n    bottom: 25px;\n    right: 20px;\n    border-radius: 20px;\n    width: 400px;\n    z-index: 5000;\n    padding: 20px;\n    background-color: #fff;\n    -webkit-box-shadow: 14px 14px 26px -4px rgba(194,194,194,1);\n    -moz-box-shadow: 14px 14px 26px -4px rgba(194,194,194,1);\n    box-shadow: 14px 14px 26px -4px rgba(194,194,194,1);\n    border: 1px solid #007932;\n    border-left: 12px solid #007932;\n}\n\n.cookie-banner .titulo{ font-size: 18px; }\n.cookie-banner .titulo svg{ font-size: 24px; }\n\n.cookie-banner .aceptar{ \n    background-color: #007932;\n    color: #fff;\n}\n\n.cookie-banner button:hover{ \n    background-color: #000;\n    border: 2px solid #000;\n}\n\n/* .guest.menu .menuLanding {\n    margin-bottom: 10px;\n} */\n\n.guest .submenuTecnico{\n    margin-bottom: 30px;\n    display: none;\n}\n\n@media (max-width: 1024px) {\n  .main-menu-border {\n   overflow-x: scroll;\n     scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* IE and Edge */\n  }\n\n  .guest .submenuTecnico {\n    padding-left: 30px;\n    padding-right: 30px;\n}\n\n  .menu .menuLanding {\n    padding: 30px 30px;\n}\n\n  .main-menu-border::-webkit-scrollbar {\n  display: none; /* Chrome, Safari, Opera */\n}\n\n  .submenuTecnico {\n    gap: 3rem;\n}\n}\n\n\n\n@media (min-width: 1024px){\n    .guest .submenuTecnico{\n   display: flex\n}\n}\n\n\n\n@media (max-width: 820px) {\n    .menu .menuLanding{ padding: 20px 30px; }\n    \n    .funding-text p {\n        font-size: 10px;\n        max-width: 300px;\n    }\n}\n\n@media (max-width: 768px) {\n    .inicio {\n        order: 0;\n        border: none;\n        padding: 0px;\n    }\n\n    .registro{ order: 1; }\n\n    .menu .logo { width: 120px; }\n    \n    .logo-section {\n        gap: 15px;\n    }\n    \n    .funding-text {\n        margin-left: 15px;\n    }\n    \n    .funding-text p {\n        font-size: 9px;\n        max-width: 250px;\n        line-height: 1.2;\n    }\n}\n\n@media (max-width: 600px) {\n    /* .menu .menuLanding{ margin: 20px 7.5%; } */\n    .menu .menuLanding .botones { gap: 15px; }\n    \n    .logo-section {\n        gap: 10px;\n    }\n    \n    .funding-text {\n        margin-left: 10px;\n    }\n    \n    .funding-text p {\n        font-size: 8px;\n        max-width: 200px;\n    }\n}\n\n@media (max-width: 400px) {\n    .menu .menuLanding .botones { \n        flex-direction: column;\n        gap: 5px; \n    }\n    \n    .funding-text {\n        display: none; /* Hide funding text on very small screens */\n    }\n}\n\n.notificacion-alerta {\n    position: relative;\n  }\n  \n  .notificacion-alerta::after {\n    content: \"\";\n    position: absolute;\n    top: -5px;\n    right: -5px;\n    width: 10px;\n    height: 10px;\n    background-color: red;\n    border-radius: 50%;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
